
import { Component, Vue } from 'vue-property-decorator'
import { ViewType } from '@/store/state'
import { MutationTypes } from '@/store/mutations'

@Component({
	components: {}
})
export default class AppHeader extends Vue {
	get showHelp() {
		return this.$tStore.state.showOverview
	}

	set showHelp(val) {
		this.$tStore.commit(MutationTypes.SET_SHOW_OVERVIEW, val)
	}

	get selectedView() {
		return this.$tStore.state.selectedView
	}

	get cbDataLoaded() {
		return this.$tStore.state.cloudData !== null
	}

	get seasonEnabled() {
		return this.cbDataLoaded && this.$tStore.state.selectedSeasonIndex !== null
	}

	get mapEnabled() {
		return this.$tStore.state.selectedFeature !== null
	}

	setView(viewId: ViewType) {
		if (viewId === 'season' && !this.seasonEnabled) {
			return
		}
		if (viewId === 'map' && !this.mapEnabled) {
			return
		}
		this.$tStore.commit(MutationTypes.SET_SELECTED_VIEW, viewId)
	}
}
